import { Component } from 'react';
import React from 'react';
import { Provider} from 'react-redux';

import axios from 'axios';

import Routes from './routes';

import store from './store/store';
import { setEstateData, setEstateError } from './store/estateActions';
import { setChambresRange, setChambresValues, setSurfaceRange, setPrixRange, setSurfaceValues, setPrixValues, setBienType } from './store/filtersActions';

var convert = require('xml-js');

window.proxyUrl = 'https://api.codetabs.com/v1/proxy?quest=';
const dataUrl = window.proxyUrl+'https://appartements-parisiens.com/wp-content/uploads/wpallimport/files/apptsparisiens.xml';

class App extends Component {

    constructor(props){
        super(props);
        this.update();
    }

    update() {
        axios({
            method: 'GET',
            url: dataUrl,
            timeout: 8000
        })
        .then(res => this.parse(res.data))
        .catch(err => {
            //TODO: handle proxy down with multiple proxies
            store.dispatch(setEstateError());
            console.log(err)
        })
    }

    setImageProxy(estates) {
        estates.forEach(estate => {
            if (estate.images) {
                let transformedImagesArray =  estate.images.image.map(i => {
                    return {
                        _cdata: window.proxyUrl + i._cdata
                    }
                });
                estate.images.image = transformedImagesArray;
            }
        })
        return estates;
    }

    parse(text) {
        try {
            var apartments = convert.xml2json(text, {compact: true, spaces: 4});
            apartments = JSON.parse(apartments).hektor.ad;
            apartments = this.setImageProxy(apartments);
            this.prepareDataForFilters(apartments);
        } catch (error) {
            console.log(error);
            store.dispatch(setEstateError());
        }
    }

    prepareDataForFilters(apartments){
        store.dispatch(setEstateData(apartments));
        store.dispatch(setBienType([...new Set(apartments.map(estate => estate.type_bien ? estate.type_bien._cdata : ""))].map(estate => {
            return {
                key: estate,
                text: estate,
                value: estate,
                label: estate.toUpperCase(),
                checked: true
            }
        })));
        let values = [
            Math.min.apply(Math, apartments.filter(a => a.chambres ? true : false).map(a => parseInt(a.chambres._text))),
            Math.max.apply(Math, apartments.filter(a => a.chambres ? true : false).map(a => parseInt(a.chambres._text)))
        ];
        store.dispatch(setChambresRange(values));
        store.dispatch(setChambresValues(values));

        values = [
            Math.min.apply(Math, apartments.filter(a => a.surface_habitable ? true : false).map(a => parseInt(a.surface_habitable._cdata))),
            Math.max.apply(Math, apartments.filter(a => a.surface_habitable ? true : false).map(a => parseInt(a.surface_habitable._cdata)))
        ];
        store.dispatch(setSurfaceRange(values));
        store.dispatch(setSurfaceValues(values));

        values = [
            Math.min.apply(Math, apartments.filter(a => a.prix ? true : false).map(a => parseInt(a.prix._text))),
            Math.max.apply(Math, apartments.filter(a => a.prix ? true : false).map(a => parseInt(a.prix._text)))
        ];
        store.dispatch(setPrixRange(values));
        store.dispatch(setPrixValues(values));
    }

    render() {
        return (
            <Provider store={store}>
                <Routes />
            </Provider>
        )
    }
}

export default App;
